import React, { FC } from 'react';
import { connect } from 'react-redux';

import ComposeDraft from '../../../components/Compose/ComposeDraft';

import useAttachmentsUpload from '../../../hooks/attachments/useAttachmentUpload';
import useParamTemplateId from '../../../hooks/router/params/useParamTemplateId';

import useParamTopicId from '../../../hooks/router/params/useParamTopicId';
import useComposeActionsRedirect from '../hooks/useComposeActionsRedirect';

import { mapDispatchToProps, mapStateToProps } from './redux';
import { Props } from './types';

/**
 * Container for compose draft
 *
 * @param props                   Props passed to the container
 * @param props.isDraftChanged    Whether the draft has been changed
 * @param props.nodeType          The type of the compose form
 * @param props.requestDraftClear Request that the draft is cleared
 * @param props.shouldShow        Whether the compose modal should be shown
 * @param props.topicId           The ID of the topic
 * @returns                       The container itself
 */
const ComposeDraftContainer: FC<Props> = ({
  isDraftChanged,
  nodeType,
  requestDraftClear,
  shouldShow,
  topicId,
}) => {
  const nodeId = useParamTemplateId();
  const topicIdParam = useParamTopicId();

  const isDefaultTopicChanged = topicId !== null && topicId !== topicIdParam;
  const isChanged = isDraftChanged || isDefaultTopicChanged;

  const { requestSubmitRedirect } = useComposeActionsRedirect(nodeId);
  const { handleClearDraft } = useAttachmentsUpload(nodeType);

  if (!shouldShow && !isChanged) {
    return null;
  }

  /**
   * Request closing the compose form
   */
  const requestDiscard = () => {
    handleClearDraft();
    requestDraftClear();
    requestSubmitRedirect();
  };

  return <ComposeDraft requestDiscard={requestDiscard} />;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ComposeDraftContainer);
